import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import Modal from '../../Modal/Modal';
import Input from '../../Input/Input';

const CarNoteModal = ({
 toggleVisible, visible, onSave, note: userNote
}) => {
  const [note, setNote] = useState(userNote);

  useEffect(() => {
    setNote(userNote);
  }, [userNote]);

  return (
    <Modal
      toggleVisible={toggleVisible}
      onSave={() => onSave(note)}
      title="Add car note"
      saveText="Save"
      visible={visible}
      hideCloseBtn
      canSave={false}
    >
      <div>
        <Input
          multiline
          type="text"
          name="car_note_text"
          value={note}
          placeholder="type note"
          onChange={({ target: { value } }) => setNote(value)}
        />
      </div>
    </Modal>
  );
};

CarNoteModal.propTypes = {
  visible: PropTypes.bool,
  toggleVisible: PropTypes.func,
  onSave: PropTypes.func,
  note: PropTypes.string
};

CarNoteModal.defaultProps = {
  visible: false,
  toggleVisible: () => {},
  onSave: () => {},
  note: ''
};

export default CarNoteModal;
